import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.showModal()
    if (Turbo.navigator.currentVisit) {
      Turbo.navigator.currentVisit.complete()
    }
    this.modalTarget.addEventListener("hidden.bs.modal", () => {
      this.element.remove()
    })
  }

  showModal() {
    const modal = new bootstrap.Modal(this.modalTarget)
    modal.show()
  }

  close() {
    const modal = bootstrap.Modal.getInstance(this.modalTarget)
    if (modal) {
      modal.hide()
    }
  }
}
